exports.components = {
  "component---src-pages-healthcheck-jsx": () => import("./../../../src/pages/healthcheck.jsx" /* webpackChunkName: "component---src-pages-healthcheck-jsx" */),
  "component---src-templates-about-us-js": () => import("./../../../src/templates/aboutUs.js" /* webpackChunkName: "component---src-templates-about-us-js" */),
  "component---src-templates-satisfaction-guaranteed-js": () => import("./../../../src/templates/satisfactionGuaranteed.js" /* webpackChunkName: "component---src-templates-satisfaction-guaranteed-js" */),
  "component---src-templates-static-page-js": () => import("./../../../src/templates/staticPage.js" /* webpackChunkName: "component---src-templates-static-page-js" */)
}

